export default {
	bizOrder: {
		title: '工单管理',
		query: {
			title: '工单名称',
			status: '处理状态'
		},
		table: {
			title: '工单标题',
			deviceName: '设备名称',
			deviceNo: '设备编号',
			status: '工单状态',
			toPersonName: '处理人员',
			fromPersonName: '申报人员',
			createTime: '工单生成时间',
			wlevel: '告警等级',
			warnCount: '告警次数',
			action: '操作'
		},
		buttons: {
			add: '新增',
			deleteBatch: '批量删除',
			handle: '处理',
			detail: '详情',
			close: '关闭',
			cancel: '取消',
			confirm: '确定',
			diagnosis: '诊断',
			delete: '删除'
		},
		form: {
			title: '标题',
			content: '内容',
			remark: '备注',
			attachmentList: '附件'
		},
		dialog: {
			add: '新增工单',
			update: '完成工单',
			detail: '工单详情',
			warnInfo: '告警信息'
		},
		messages: {
			operationSuccess: '操作成功',
			deleteConfirm: '确定要删除吗？',
			batchDeleteConfirm: '确定要批量删除吗？'
		},
		warnList: {
			title: '告警列表',
			warnTitle: '告警标题',
			pointName: '测点名称',
			pointId: '测点编号',
			dataType: '数据类型',
			wlevel: '告警等级',
			handleStatus: '状态',
			startTime: '开始时间',
			predTime: '最后告警',
			eigenKey: '特征值',
			content: '内容',
			standardData: '参考值',
			predData: '实际值',
			warnCount: '告警次数',
			type: '告警类型',
			suggest: '建议',
			warnType: '告警分类'
		}
	}
}
